<template>
  <div>
    <div v-show="value">
      <div class="continuumDialog">
        <button
          v-on:click="closeContinuum"
          class="cursor-pointer"
          style="float: right; position: relative"
          aria-label="Close"
        >
          <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="18" cy="18" r="18" fill="#F2F2F2"></circle>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.3969 12.2496C11.5347 12.1117 11.7582 12.1117 11.8961 12.2496L23.7513 24.1048C23.8891 24.2426 23.8891 24.4661 23.7513 24.604C23.6134 24.7418 23.3899 24.7418 23.2521 24.604L11.3969 12.7488C11.259 12.6109 11.259 12.3874 11.3969 12.2496Z"
              fill="#0C0707"
              stroke="#3F3D56"
              stroke-linecap="round"
            ></path>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M11.2496 24.6041C11.1117 24.4662 11.1117 24.2427 11.2496 24.1049L23.1048 12.2497C23.2426 12.1119 23.4661 12.1119 23.604 12.2497C23.7418 12.3876 23.7418 12.6111 23.604 12.7489L11.7488 24.6041C11.6109 24.7419 11.3874 24.7419 11.2496 24.6041Z"
              fill="#0C0707"
              stroke="#3F3D56"
              stroke-linecap="round"
            ></path>
          </svg>
        </button>
        <h2 class="text-lg font-bold">The Carleton Mental Health Continuum</h2>
        <br />
        <p class="text-x">
          {{ description }}
        </p>
        <div style="text-align: left">
          <a
            type="button"
            class="newContinuumButtons"
            target="_blank"
            href="https://carleton.ca/wellness/living-well/resources/"
          >
            <span class="arrow">
              <svg
                width="14"
                height="12"
                viewBox="0 0 14 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.63466 0.298041C8.45622 0.109282 8.20838 0 7.9308 0C7.38556 0 6.93945 0.447062 6.93945 0.99347C6.93945 1.27164 7.0485 1.52001 7.22694 1.69883L10.4885 4.96735H0.99135C0.446108 4.96735 0 5.41441 0 5.96082C0 6.50723 0.446108 6.95429 0.99135 6.95429H10.4984L7.23686 10.2228C7.05842 10.4016 6.94937 10.65 6.94937 10.9282C6.94937 11.4746 7.39547 11.9216 7.94072 11.9216C8.2183 11.9216 8.46613 11.8124 8.64458 11.6335L13.6013 6.66618C13.7798 6.48736 13.8888 6.23899 13.8888 5.96082C13.8888 5.68265 13.7699 5.44422 13.5914 5.26539L8.63466 0.298041Z"
                  fill="#8380A8"
                />
              </svg> </span
          ></a>
        </div>
      </div>
      <div
        v-on:click="closeContinuum"
        class="fixed w-full h-full bg-black top-0 bottom-0 opacity-20 z-30"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContinuumModal",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      continuumNotice: true,
      description:
        "Carleton provides a wide variety of accessible resources and services that allow students to maximize and manage their mental health and well-being. This guide can assist in matching students to the appropriate level of support based on their specific needs.",
    };
  },
  methods: {
    closeContinuum() {
      this.$emit("input", !this.value);
    },
  },
};
</script>

<style lang="css" scoped>
.newContinuumButtons::before {
  content: "Download Resource Guide";
}

.newContinuumButtons {
  width: 17rem;
}

@media only screen and (max-width: 440px) {
  .newContinuumButtons::before {
    content: "Download";
  }

  .newContinuumButtons {
    width: 10rem;
  }
}

.continuumDialog {
  @apply fixed p-8 bg-white shadow-lg z-50;
  margin-left: 1rem;
  margin-right: 1rem;
  text-align: left;
  top: 50%;
  left: 0;
  right: 0;
  margin: auto;
  transform: translateY(-50%);
  width: 50%;
  border-radius: 20px;
}

@media only screen and (max-width: 768px) {
  .continuumDialog {
    width: 75%;
  }
}

@media only screen and (max-width: 640px) {
  .continuumDialog {
    max-height: calc(100vh - 100px);
    overflow-y: auto;
    position: fixed;
    @apply p-8;
  }
}
</style>
